import React, {Suspense} from 'react'
import AccountIcon from 'react-icons/lib/md/account-circle'
import InboxIcon from 'react-icons/lib/md/inbox'
import styles from './styles.css'
import UserAccount from './UserAccount'
import BalancerStatus from './BalancerStatus'

export default function UserMenu() {
  return (
    <div className={styles.container}>
      <div className={styles.itemsContainer}>
        <div className={[styles.item, styles.logoContainer].join(' ')}>
          <img src="/iso-dark.svg" className={styles.logo} alt="Logo" />
        </div>
        <div className={styles.item}>
          <BalancerStatus />
        </div>
        <div className={[styles.item, styles.selectedItem].join(' ')}>
          <InboxIcon size="30" />
        </div>
      </div>
      <div className={styles.account}>
        <Suspense fallback={<AccountIcon size="32" />}>
          <UserAccount />
        </Suspense>
      </div>
    </div>
  )
}
